/**
 * @author: Michal Mlčoch <xmlcoc12@stud.fit.vutbr.cz>
 */

import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import {Divider, Grid, Link} from '@mui/material';
import { useNavigate } from "react-router-dom";
import {statusList} from "../auctionsToConfirm/AuctionsToConfirm";

function AuctionCard(props) {

    const auction = props.auction;
    let navigate = useNavigate();
    const typeList = {
        "OPEN": 'Otevřená',
        "CLOSED": 'Uzavřená',
    }

    const typeOffer = {
        "OFFER": 'Nabídka',
        "DEMAND": 'Poptávka',
    }

    return (
        <Card className="card">
            <CardContent>
                <Typography variant="body2" color="info.main">
                    {typeOffer[auction.offerType]} | {typeList[auction.type]} | {statusList[auction.status]}
                </Typography>
                <Divider />
                <div className="pictureContainer">
                    <img src={auction.previewPicture != null ? auction.previewPicture.path : ""} className="previewPicture" />
                </div>
                <Typography variant="h5" component="div" className="auctionTitle">
                    {auction.title}
                </Typography>
                <Typography sx={{ mb: 1.5 }} color="text.secondary">
                    {auction.category.title}
                </Typography>
                <Typography sx={{ mb: 1 }} color="text.secondary">
                    Konec: {(new Date(auction.endAt)).toLocaleString("cs-CZ")}
                </Typography>
                <Typography variant="body2" className="auctionDescription">
                    {auction.description}
                </Typography>
            </CardContent>
            <CardActions>
                <Button
                    onClick={() => navigate(`/auctions/${auction.id}`)}
                    size="small">
                    Zobrazit aukci
                </Button>
            </CardActions>
        </Card>
    )
}

export default AuctionCard;